/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMusicResourceRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/music.pb'
import {GetMusicResourceResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/music.pb'


export const getMusicResource = (request: GetMusicResourceRequest, options?: CashRequestOptions) => post<GetMusicResourceRequest, GetMusicResourceResponse>("/2.0/cash/get-music-resource", request, {...options, rejectOnError: true })